import { render, staticRenderFns } from "./Medisalidas.vue?vue&type=template&id=77c68ca4"
import script from "./Medisalidas.vue?vue&type=script&lang=js"
export * from "./Medisalidas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports